import { i18n } from "@/plugins/i18n";

export class SafeboxTransfer {
  columns = [];
  id = "id";

  fillAbles = [
    ["fromSafeboxId", i18n.t("fromSafeboxId"), true, false],
    ["fromSafebox", i18n.t("fromSafeBox"), true],
    ["toSafeboxId", i18n.t("toSafeboxId"), true, false],
    ["toSafebox", i18n.t("toSafeBox"), true],
    ["invoiceNumber", i18n.t("invoiceNumber"), true],
    ["mcPrice", i18n.t("mcPrice"), true],
    ["dateTime", i18n.t("date"), true],
    ["note", i18n.t("note"), true],
    ["attachment", i18n.t("attachment"), true],
    ["controls", i18n.t("controls"), false],
  ];

  getColumns() {
    this.columns = [
      {
        label: i18n.t("id"),
        name: "id",
        sort: false,
        visibility:
          process.env.VUE_APP_PROJECT_NAME === "MassHills" ? false : true,
        uniqueId: true,
      },
    ];
    this.fillAbles.map((e) => {
      this.columns.push({
        name: e[0],
        label: e[1],
        sort: e[2],
        visibility: e[3] ?? true,
      });
    });
    return this.columns;
  }
}
